module.exports = __webpack_public_path__ + "static/img/fish6.4afe0ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish6.png
// module id = SBa8
// module chunks = 0